
<template>
  <section
    class="event-pbox"
    id="about-history"
    style="background-image: url(/images/history-1.png)">
    <div ref="eventbox" class="eventBox">
      <dl ref="eventlist" class="event-list">
        <dd v-for="(item, index) in items"
          :key="item.ID"
          :class="`itembox${index%2}`">
          <!-- @click="goCenter" -->
          <i class="ico"></i>
          <p class="year">{{ item.PRONAME }}</p>
          <div class="item">
            {{ item.MS }}
          </div>
        </dd>
        <dd v-for="(item, index) in items"
          :key="item.ID * 2"
          :class="`itembox${index%2}`">
          <!-- @click="goCenter" -->
          <i class="ico"></i>
          <p class="year">{{ item.PRONAME }}</p>
          <div class="item">
            {{ item.MS }}
          </div>
        </dd>
      </dl>
    </div>
    <!-- <p class="event-mouse">TIPS: 横向滚动历史年轮~</p> -->
  </section>
</template>

<script>
// import Scrollbar from 'smooth-scrollbar'
import { qsa } from '@/util/dom.js'
import { getHistoryUrl } from '@/util/url.js'
import axios from 'axios'

export default {
  data () {
    return {
      items: []
    }
  },

  // beforeDestroy () {
  //   // this.scrollbar.removeListener(this.scrollListener)
  //   // this.scrollbar.destroy()
  //   // this.scrollbar = null
  // },

  mounted () {
    this.fechData()
  },

  methods: {
    // scrollListener (status) {
    //   console.log(status)
    //   // const { offset, limit } = status
    //   // if (offset.x > 50 && offset.x < limit.x - 50) {
    //   //   window.scrollBar.updatePluginOptions('modal', { open: true })
    //   // } else {
    //   //   window.scrollBar.updatePluginOptions('modal', { open: false })
    //   // }
    // }

    // mousewheel (e) {
    //   console.log(e)
    // }

    fechData () {
      const url = getHistoryUrl(this.$store.state.lang)
      axios.get(url).then(res => {
        if (res && res.data && res.data.proarr && res.data.proarr.length > 0) {
          this.items = res.data.proarr
          // this.fechView()
        }
      })
    },

    fechView () {
      this.$nextTick(() => {
        const dds = qsa('.event-list dd', this.$refs.eventlist)
        const w = window.innerWidth

        this.$refs.eventlist.style.paddingLeft = (w / 2) + 'px'
        this.$refs.eventlist.style.width =
          (dds.length * 326 + w) + 'px'
        this.go(w - 210)
      })
    },

    goCenter (e) {
      const x = e.clientX || e.pageX || e.x
      this.go(x)
    },

    go (x) {
      const s = window.innerWidth / 2
      const l = this.$refs.eventbox.scrollLeft

      // console.log({ x, s, l })

      this.$refs.eventbox.scrollTo(l + x - s, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.event-pbox {
  background-position: center top;
  background-size: cover;
  color: #fff;
  padding-top: 190px;
  padding-bottom: 60px;
  position: relative;
}
.eventBox {
  width: 100%;
  height: 520px;
  // overflow-x: hidden;
  // overflow-x: scroll;
  position: relative;
}
.eventBox a:link,
.eventBox a:visited {
  color: #fff;
}
.eventBox a:active,
.eventBox a:hover {
  color: #fff;
}
.event-list {
  width: 5216px;
  height: 600px;
  // padding-left: 210px;
  position: absolute;
  animation: roll 20s linear infinite;
  // white-space: nowrap;
}

.event-list:hover {
  animation-play-state: paused;
}

.event-list dd {
  float: left;
  display: block;
  width: 326px;
  height: 448px;
  position: relative;
}
.event-list .year {
  transform: translateY(-48px);
  font-size: 40px;
  line-height: 1.2;
  font-family: "DINCondMedium";
}
.event-list .itembox0:not(:last-child) {
  background: url(/images/fj_x1.png) no-repeat scroll 44px 54%;
}
.event-list .itembox1 {
  padding-top: 400px;
  height: auto;
}
.event-list .itembox1:not(:last-child) {
  background: url(/images/fj_x2.png) no-repeat scroll 44px 41%;
}

.event-list .item {
  transform: translateY(-48px);
  font-size: 16px;
  line-height: 1.5;
  height: 96px;
  // overflow: hidden;
}
.event-list .ico {
  background: url(/images/fj.png) no-repeat scroll center center;
  width: 44px;
  height: 44px;
  border-radius: 22px;
  position: absolute;
  left: 0;
  cursor:pointer;
  // border:1px solid #2b92d4;
  overflow:hidden;
  box-shadow:0 1px 2px rgba(0,0,0,.3);
  animation-timing-function:ease-in-out;
  animation-name:breathe;
  animation-duration:2000ms;
  animation-iteration-count:infinite;
  animation-direction:alternate;
}

@keyframes roll {
  from {
    transform: translate(0, 0);
  }
  to {
    transform: translate(-50.2%, 0);
  }
}

@keyframes breathe {
  0% {
    opacity: 0.6;
    box-shadow: 0 1px 2px rgba(255,255,255,0.1);
  }

  100% {
    opacity:1;
    // border: 1px solid rgba(59,235,235,1);
    box-shadow: 0 1px 30px rgb(49, 198, 243);
  }
}

.event-list .itembox0 .ico {
  top: 154px;
}
.event-list .itembox1 .ico {
  top: 274px;
}
.event-mouse {
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 80px;
  color: #8fd6ed;
}

@media (max-width: 1440px) {
  .event-pbox {
    padding-top: 100px;
  }
  .event-list {
    height: 520px;
    // padding-left: 150px;
  }
  .event-list .year {
    font-size: 32px;
  }
  .event-list .item {
    font-size: 16px;
    height: 72px;
  }
  .event-list dd {
    height: 380px;
  }
  .event-list .itembox1 {
    padding-top: 340px;
  }
  .event-list .itembox0 .ico {
    top: 116px;
  }
  .event-list .itembox1 .ico {
    top: 238px;
  }
}

@media (max-width: 1024px) {
  .event-pbox {
    padding: 55px 0px;
    background: none #fff !important;
    color: #777;
  }
  .event-pbox .mCSB_container {
    width: 100% !important;
    left: 0 !important;
  }
  .eventBox {
    width: 90%;
    margin: 0px auto;
  }
  .event-list {
    width: 100% !important;
    height: auto;
    padding-left: 0;
  }
  .event-list .itembox0,
  .event-list .itembox1 {
    background: none;
  }
  .event-list dd {
    overflow: hidden;
    width: auto;
    float: none;
    display: block;
    height: auto;
    padding-left: 40px;
    position: relative;
    margin-bottom: 15px;
    padding-bottom: 5px;
  }
  .event-list dd:before {
    content: "";
    position: absolute;
    left: 21px;
    top: 30px;
    width: 1px;
    height: 100%;
    background-color: #777;
  }
  .event-list .itembox1 {
    padding-top: 0;
  }
  .event-list .itembox0 .ico,
  .event-list .itembox1 .ico {
    top: 2px;
    transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
  }
  .event-list .item {
    height: auto;
  }
  .event-list .year {
    color: #00448a;
    font-size: 30px;
    line-height: 1;
    margin-bottom: 8px;
  }
  .event-list .item {
    font-size: 16px;
  }
  .event-mouse {
    display: none;
  }
}

@media (max-width: 768px) {
  .eventBox{
    height: auto;
    .event-list{
      position: static;
      animation:none;
    }
  }
  .event-list .year {
    transform: translate(0);
  }
  .event-list .item {
    transform: translate(0);
  }
}

@media (max-width: 640px) {
  .event-list .year {
    font-size: 28px;
  }
  .event-list .item {
    font-size: 15px;
  }
}
</style>
